module.exports = __webpack_public_path__ + "img/score_card_howto.cf0874c3.png";